export default {
    tile: {
        overflow: 'visible',
    },
};
